<div class="recommendation-panel-layout layout-column"
     [ngClass]="'direction-' + direction">
  <div class="title-container layout-row">
    <div class="title-section layout-row layout-align-start-center">
      <bringoz-icon fill="blue" iconName="star-blue"></bringoz-icon>
      <div class="panel-title">{{ 'Recommendations' | translate }}</div>
    </div>
    <span flex></span>

    <bringoz-button *ngIf="generateRecommendationsAllowed"
                    type="tertiary"
                    size="sm"
                    (onClick)="onSelectAgent($event)">
      <span>{{ 'RECOMMENDATIONS.GENERATE_RECOMMENDATIONS' | translate }}</span>
    </bringoz-button>

    <bringoz-button type="tertiary"
                    size="sm"
                    class="close-button"
                    (onClick)="closePanel()">
      <bringoz-icon classSize="xl" iconName="close"></bringoz-icon>
    </bringoz-button>
  </div>

  <div class="recommendations-list-wrapper flex layout-column">
    <app-recommendations-list-items
      [recommendations]="recommendations$ | async"
      [loading]="loading$ | async"
      [showRecommendationLink]="false"
      [direction]="direction"
      (fetchNextEvent)="onFetchNext()"
      (updateRecommendation)="updateRecommendationFeedback($event)"
      (markRecommendationAsRead)="markRecommendationAsRead($event)"
      (applyRecommendation)="applyRecommendation($event)"
      (openRoutePanelsByIds)="openRoutePanelsByIds.emit($event)"
    >
    </app-recommendations-list-items>
  </div>
</div>
